import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './base/Button';
import modalStyles from './Modal.module.css';
// The body/message/warning chrome originated with DeleteTemplateModal and was already imported
// across folders by every delete modal. It stays put so this extraction changes no CSS at all.
import styles from '../Configuration/DeleteTemplateModal.module.css';

// Every "are you sure?" modal in the app is the same shape: a title, a message naming the thing,
// an optional line spelling out the consequence, and a cancel/confirm pair. Callers keep their own
// translation keys and pass resolved strings, so the copy stays with the feature that owns it
// while the layout lives here once.
const MODAL_WIDTH = 480;

interface ConfirmationModalProps {
  title: string;
  message: ReactNode;
  /** Quieter second line describing what confirming will cost. Omitted when there is none. */
  warning?: string;
  cancelLabel: string;
  confirmLabel: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const ConfirmationModal = ({
  title,
  message,
  warning,
  cancelLabel,
  confirmLabel,
  onConfirm,
  onClose
}: ConfirmationModalProps) => (
  <Modal
    title={title}
    onClose={onClose}
    width={MODAL_WIDTH}
    footer={
      <div className={modalStyles.footerRow}>
        <Button type="secondary" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button type="primary" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    }
  >
    <div className={styles.body}>
      <p className={styles.message}>{message}</p>
      {warning && <p className={styles.warning}>{warning}</p>}
    </div>
  </Modal>
);
